/**
 * @generated SignedSource<<a37ec3dbdf4eddc2512ae0575cf74af9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type loadProductWithCodeQuery$variables = {
  productCode: string;
  salesChannelId: string;
};
export type loadProductWithCodeQuery$data = {
  readonly modelIDByCode: string;
};
export type loadProductWithCodeQuery = {
  response: loadProductWithCodeQuery$data;
  variables: loadProductWithCodeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productCode"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "salesChannelId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "code",
        "variableName": "productCode"
      },
      {
        "kind": "Variable",
        "name": "salesChannelId",
        "variableName": "salesChannelId"
      }
    ],
    "kind": "ScalarField",
    "name": "modelIDByCode",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "loadProductWithCodeQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "loadProductWithCodeQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "dceb123c28f9874855c832cfe04f48b3",
    "id": null,
    "metadata": {},
    "name": "loadProductWithCodeQuery",
    "operationKind": "query",
    "text": "query loadProductWithCodeQuery(\n  $productCode: String!\n  $salesChannelId: String!\n) {\n  modelIDByCode(code: $productCode, salesChannelId: $salesChannelId)\n}\n"
  }
};
})();

(node as any).hash = "bb9cd5424bbba1b828ef4f89a4b4571e";

export default node;
